import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle: string;
  progress: number;
  progressLabel: string;
  trend?: string;
  trendUp?: boolean;
  variant?: 'default' | 'primary';
  icon?: React.ReactNode;
  rotate?: number;
  'data-id'?: string;
}
export function MetricCard({
  title,
  value,
  subtitle,
  progress,
  progressLabel,
  trend,
  trendUp,
  variant = 'default',
  icon,
  rotate = 0,
  'data-id': dataId
}: MetricCardProps) {
  const isDefault = variant === 'default';
  return;
}